const meta_data = {
    "meta.title.home": "安視優®睛漾水凝®每日拋",
    "meta.desc.home": "融合自然、科學、藝術的極致工藝，精心打造的日拋鏡片，為您帶來絕佳美感，讓您的眼睛更健康、更舒適。",
    "meta.title.vm": "線上試戴安視優®睛漾水凝®隱形眼鏡",
    "meta.desc.vm": "找到最適合您的安視優®睛漾水凝®每日拋隱形眼鏡。",
    "meta.title.discover": "了解安視優®睛漾水凝®系列",
    "meta.desc.discover": "透過睛漾水凝®花眸系列及經典系列，輕鬆打造出屬於您的自然之美。",
    "meta.title.classic": "了解睛漾水凝®經典系列",
    "meta.desc.classic": "安視優®睛漾水凝®花眸系列每日拋，閃耀天生魅力的自然大地色，突顯您的美眸。",
    "meta.title.fresh": "了解安視優®睛漾水凝®花眸系列",
    "meta.desc.fresh": "安視優®睛漾水凝®花眸系列每日拋，綻放剔透光彩的自然混血感，打造出屬於您的自然之美。",
}

export default meta_data;